import { config } from '_/config/config';
import _ from 'lodash';
import { api } from '_/services/api';
import { pWarn } from '_/helpers/logger';
import { mapGetters } from 'vuex';

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        canCreateSearchChoice: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
        },
        flattenToOptgroups: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        isActiveEntryFilter: {
            default: null,
            type: String,
        },
        lazyLoading: {
            type: Boolean,
        },
        multiple: {
            type: Boolean,
        },
        name: {
            required: true,
            type: String,
        },
        optionsData: {
            type: Array,
        },
        placeholder: {
            type: String,
        },
        preloadDataConfig: {
            default() {
                return {
                    method: 'post',
                    payload: {
                        include_relations: false,
                    },
                    resultsObjectPath: 'body.body.entries',
                    valuesOfInterest: {
                        id: 'id',
                        text: 'anchor_text',
                    },
                    url: false,
                };
            },
            type: Object,
        },
        preselectFirst: {
            default: false,
            type: Boolean,
        },
        refreshFields: {
            type: Number,
        },
        relatedTableName: {
            type: [Boolean, String],
        },
        required: {
            type: Boolean,
        },
        value: {
            default: null,
            type: [Array, Number, Object, String],
        },
        focus: {
            default: false,
            type: Boolean,
        },
    },

    data: function () {
        return {
            fields: [],
            radioValue: '',
        };
    },

    /**
     * Set the computed properties
     *
     * @type  {object}
     */
    computed: {
        // Map getters
        ...mapGetters({
            admin: 'admin/admin',
        }),
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            this.getData().then(() => {
                $(this.$el).find('input[type="radio"]').uniform();
                if (this.focus) {
                    $(this.$el).find(`#${this.name}-${this.fields[0].id}`)[0].focus();
                }
            });

            if (this.value instanceof Object) {
                this.radioValue = this.value.id;
            }
        });
    },

    methods: {
        getData() {
            let payload = {
                filter: {
                    anchor_text: {},
                },
                modules: [this.relatedTableName],
                include_relations: false,
            };

            if (self.isActiveEntryFilter) {
                _.set(payload, `filter.${self.isActiveEntryFilter}.equal`, true);
            }

            return api
                .post(
                    `${config.ENV.apiBasePath}/filter?include=parent_id&include=${this.preloadDataConfig.valuesOfInterest.id}&include=${this.preloadDataConfig.valuesOfInterest.text}`,
                    payload
                )
                .then(
                    function (response) {
                        this.fields = response.body.body.entries;
                    }.bind(this)
                );
        },
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `InputTag.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.$forceUpdate();

                if (this.admin.editorMode !== 'create') {
                    if (this.value instanceof Object) {
                        this.radioValue = this.value.id;
                    }
                } else {
                    this.radioValue = '';
                }

                this.$nextTick(() => {
                    $.uniform.update();
                    if (this.focus) {
                        $(this.$el).find(`#${this.name}-${this.fields[0].id}`)[0].focus();
                        this.$nextTick(() => {
                            $(this.$el).find(`#uniform-${this.name}-${this.fields[0].id}`)[0].classList.add('focus');
                        });
                    }
                });
            }
        },
        radioValue: function () {
            this.$emit('change', {
                id: this.id,
                name: this.name,
                value: this.radioValue,
            });
        },
    },
};
